import React, { useContext } from 'react';
import { ScreenableFieldSetupContext } from '../helpers/useScreenableFieldSetupContextManager';
import { SalvFieldHeader, SalvProgressCircle } from '@salvapp/ui-components';
import { useQuerySegments } from '../../configure/segments/segmentActions';
import './SummaryStep.scss';
import { Flow } from '../../configure/new/Flow';
import { getFlow } from '../helper';
import DataLoadingErrorFallback from '../../../common/errors/DataLoadingErrorFallback';

export const SummaryStep = () => {
  const setupContext = useContext(ScreenableFieldSetupContext);
  const {
    data: segments,
    isPending: isSegmentsPending,
    isError: isSegmentsError,
  } = useQuerySegments({ entityType: setupContext.entityType });

  const flow = getFlow(setupContext);

  if (isSegmentsError) {
    return <DataLoadingErrorFallback message={'Could not load Segments'} />;
  } else if (isSegmentsPending) {
    return <SalvProgressCircle ariaLabel={'Loading Segments'} />;
  }

  return (
    <div className='p-a-24'>
      <div className='summary-step'>
        <h4 className='text-strong-m chapter-title'>Summary</h4>
        <div className='screening-flows'>
          <SalvFieldHeader label='Screenable fields' />
          <SalvFieldHeader label='Segments' />
          <SalvFieldHeader label='Matching type' />
          <SalvFieldHeader label='Screened against' />
          <Flow rowNr={1} flow={flow} segments={segments} showButtonsAndId={false} />
        </div>
      </div>
    </div>
  );
};
